import styled from '@emotion/styled';
import { Button, Result, Space } from 'antd';
import React from 'react';
import { useTranslate } from '@tolgee/react';

export interface ErrorResultProps {
  onRestart: () => any;
  onNeedHelp: () => void;
  error: React.ReactNode;
}
const Center = styled.div`
  text-align: center;
`;
const Gray = styled.span`
  color: #84868c;
`;
const Footer = styled.div`
  width: 583px;
  padding: 18px;
  background: #f7f9fa;
  text-align: left;
  box-sizing: border-box;
  margin: 18px auto;
  > h2 {
    font-weight: 700;
  }
`;
const DecorateTitle = styled.div`
  position: relative;
  padding-left: 11px;
  margin: 10px 0 12px 0;
  font-size: 16px;
  color: #232426;
  font-weight: 600;
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    display: inline-block;
    height: 1em;
    width: 0;
    vertical-align: middle;
    border-left: 5px solid var(--fett-app-primary-color);
    transform: translateY(-50%);
  }
`;
const ErrorResult = (props: ErrorResultProps) => {
  const { onRestart, error, onNeedHelp } = props;
  const { t } = useTranslate();

  return (
    <>
      <Result status="error" title={error} />
      <Center>
        <Button type="primary" onClick={onRestart}>
          {t('authShop.重新添加新的店铺')}
        </Button>
      </Center>
      <Footer>
        <h2>{t('authShop.添加店铺过程中遇到问题')}</h2>
        <DecorateTitle>{t('authShop.是否需要客户服务专家联系您协助完成添加店铺')}</DecorateTitle>
        <div>
          <Space align="end">
            <Button type="primary" onClick={onNeedHelp}>
              {t('authShop.需要协助')}
            </Button>
            <Gray>({t('authShop.工作日将在30分钟内联系')})</Gray>
          </Space>
        </div>
        <dl>
          <dd>
            <DecorateTitle>{t('authShop.常见失败原因')}</DecorateTitle>
          </dd>
          <dd>· {t('authShop.可能是帐号密码输入错误导致失败')}</dd>
          <dd>· {t('authShop.选择了与帐号不符的站点')}</dd>
          <dd>· {t('authShop.店铺类型为跨境店铺，添加时选择了普通店铺类型')}</dd>
        </dl>
      </Footer>
    </>
  );
};
export default ErrorResult;
